import React from 'react'
import LoaderButton from '../../components/LoaderButton'
import FormViewer from '../../components/FormViewer'
import { chooseWallpaper, translate } from "../../utils/useful";
import Responsive from '../../components/Responsive'
import ButtonAnimated from '../../components/buttons/ButtonAnimated';

// import HttpService from '../../utils/Http.services';

class LoginCodeStep extends React.Component {
    state = {
        key: '',
        selectedCountry: {},
        resendTime: 60,
        resendRequested: false,
        // errors:{},
        formHeaders: [{ key: 'code', type: 'CodeInput', information: { placeholder: '{{lang}}activationCode', autoFocus: true, required: true } }]
    }

    componentDidMount() {
        document.addEventListener("keydown", this._handleKeyDown);
        // this.changeResendTime()
        this.timer = setInterval(this.checkResendTime, 1000);
    }

    componentWillUnmount() {
        if (this.timer) clearInterval(this.timer)
        document.removeEventListener("keydown", this._handleKeyDown);
    }

    postCode = () => {
        this.setState({ isLoading: true, errors: {} })
        let data = this.form.getForm()

        this.props.setData(data, () => {
            this.props.postCode((result, err) => {
                if (err) { this.setState({ errors: err }) }
                this.setState({ isLoading: false })
            })
        })
    }

    requestResend() {
        if (!this.state.resendRequested) {
            this.setState({ resendRequested: true })
            this.props.userCheck((result, err) => {
                this.setState({ resendRequested: false })
                if (err) { return }
                this.setState({ canResend: false, resendTime: 60 })
            })
        }
    }

    checkResendTime = () => {
        if (this.state.resendTime > 0) {
            this.setState({ resendTime: this.state.resendTime - 1 })
        } else { this.setState({ canResend: true }) }
    }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.postCode()
        }
    }


    render() {
        return (
            <div className="d-flex w-100 flexcc pt-5 px-5">
                <Responsive height={'100%'} width={this.props.width} media={{ xs: '100%', md: "12" }}>
                    <div className="flexcc flex-column w-100">

                        <div className=' d-flex w-100'>
                            {/* <img className='prd-3' style={{width:"40px"}} src='/images/icons/lock.svg' /> */}
                            <h2 className="text-title1" style={{ cursor: 'default' }}>{translate('activation-code')}</h2>

                        </div>
                        <div className="w-100 pt-3" style={{ maxWidth: 400 }}>


                            <FormViewer ref={el => this.form = el} headers={this.state.formHeaders} initData={this.props.initData} errors={this.state.errors} inputClass={'phone-input'} nopadding={true} />

                            <div className=" pt-2 w-100">

                                {/* <LoaderButton
                                    onClick={() => this.postCode()}
                                    isLoading={this.state.isLoading}
                                    text={translate("send-code")}
                                    backgroundImage='linear-gradient(45deg, #30A1B8 0%, #5598DE 40%, #8E81F4  70%, #F45495  90%, #EE4358  100%)'
                                    shadow="0px 0px 14px -7px #007aff;"
                                    icon={'/assets/icons/angle-right-white2.svg'}
                                    className={'button-interactive-1'}
                                    language={this.props.language}
                                /> */}
                                <div className='flexcb w-100'>
                                    <p style={{ color: "#3ea0ff", cursor: 'default' }}>{'+' + this.props.initData.userIndicator.slice(2, String(this.props.initData.userIndicator).length)}</p>
                                    <ButtonAnimated icon={'/assets/icons/arrow-right-white.svg'} bg={this.props.textColor} title={'Submit'} onClick={this.postCode} isLoading={this.state.isLoading} />
                                </div>
                                <div className='pb-2'>
                                    <button className="mb-2 pt-2" onClick={() => this.props.changeStage('init')} style={{ fontSize: 15, }}>{translate('change-phone')}</button>
                                    <p style={{ fontSize: 13, opacity: 0.5, marginTop: 0, cursor: 'default' }}>{translate('if-not-recived-code')}</p>
                                    {this.state.canResend ? (
                                        <button onClick={() => this.requestResend()} className="flatButton mt-2" style={{ fontSize: 13, opacity: this.state.resendRequested ? 0.5 : 1, transition: 'all 0.4s', marginTop: 0 }}>{translate('resend request')}</button>
                                    ) : (
                                        <p className="mt-2 pb-5" style={{ fontSize: 13, opacity: 0.5, marginTop: 0, cursor: 'default' }}>{translate('resend-code-in', { seconds: this.state.resendTime })}</p>
                                    )}
                                </div>

                            </div>
                        </div>

                    </div>
                </Responsive>
            </div>
        )
    }
}

export default LoginCodeStep;